/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';

const SelectedClaimSpecialCondition = () => {
  const RedColor='#a81f00'


  return (
    <div className='col-3 mt-4'>
      <fieldset className='custom-fieldset'>
        <div className='p-0 mt-2 h-100 d-flex align-items-center justify-content-center'>
          <span style={{ color: RedColor, fontWeight: 800 }}>
            Special Condition Exist
          </span>
        </div>
      </fieldset>
    </div>
  );
};

export default SelectedClaimSpecialCondition;
